module.exports = __webpack_public_path__ + "static/media/shape0_7.83197adb.obj";